@if (step === portSteps.select_provider) {
  <app-phonenumber-port-provider
    (onBack)="back()"
    (onNext)="onProviderSelected($event)"
  ></app-phonenumber-port-provider>
}
@if (step === portSteps.select_size) {
  <app-phonenumber-port-select-size
    (onBack)="back()"
    (onNext)="onPortNumberSizeSelected($event)"
  ></app-phonenumber-port-select-size>
}
@if (step === portSteps.select_phone_numbers && selectedNumberSize === 'block') {
  <app-phonenumber-port-block
    (onBack)="stepBack()"
    (selected)="onSelectNumbersToPortComplete($event)"
  ></app-phonenumber-port-block>
}
@if (step === portSteps.select_phone_numbers && selectedNumberSize === 'single') {
  <app-phonenumber-port-single-number
    (onBack)="stepBack()"
    (selected)="onSelectNumbersToPortComplete($event)"
  ></app-phonenumber-port-single-number>
}
